


































































import { user } from '../fire.coffee'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import moment from 'moment'
import rounder from '../rounder.js'

auth = firebase.auth()
auth.onAuthStateChanged (u) =>
    loadOrders() if u?

orders = []
loadOrders = =>
    db = firebase.firestore()
    os = db.collection('orders').where('user.id', '==', user.id).orderBy('date', 'desc')
    os.onSnapshot (snap) =>
        orders.length = 0
        for index, doc of snap.docs
            order = doc.data()
            order.id = doc.id
            order.ticket_info = {}
            orders.push(order)
        return null

export default
    data: ->
        isLoading: false
        error: ''
        user: user
        orders: orders
        email_changed: false
    watch:
        "user.email": (_, old) -> this.email_changed = true unless old == ''
    computed:
        countries: -> 
            locale = this.$root.$i18n.locale
            counts = [...this.$countries()]
            index = counts.findIndex (e) -> e[locale]?
            if index > -1
                element = counts[index]
                counts.splice(index, 1)
                counts.unshift(element)
            return counts
    methods:
        rounder: rounder
        validate: ->
            unless this.user?.details?.last_name and this.user?.details?.first_name #\
            # and this.form.address.country and this.form.address.city \
            # and this.form.address.zip and this.form.address.line
                this.error = this.$t 'provide_all_fields'
                return false
            if this.user?.details?.company and not this.user?.details?.tax_id then this.error=this.$t('no_tax_id'); return false
            return true
        save: ->
            if this.isLoading then return null
            unless this.validate() then return null

            this.error = ''
            this.isLoading = true

            if this.email_changed
                try await firebase.auth().currentUser.updateEmail(user.email)
                catch e
                    this.error = this.$t('sign_in_again')
                    this.loading = false
                email_changed = false

            db = firebase.firestore()
            try await db.collection('users').doc(user.id).set(user.details)
            catch e then this.error = e.message
            finally this.isLoading = false

            # Save the country to the auth user
            this.updateProfile(this.user?.details?.address?.country)

            # Return to the event list
            this.$router.push {name: 'events'}
        
        updateProfile: (country) ->
            try await firebase.auth().currentUser.updateProfile({displayName: country})
            catch e then console.log e

        download: -> 
            obj = {...user, ...orders}
            data = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify obj, undefined, 2)
            element = document.createElement 'a'
            element.setAttribute 'href', data
            element.setAttribute 'download', this.$t('data') + ".txt"
            document.body.appendChild element
            element.click()
            element.remove()

        logout: ->
            if this.isLoading then return null
            this.error = ''
            this.isLoading = true
            firebase.auth().signOut()
            .then () => this.$router.push({ name: 'events' })
            .catch (e) => this.error = e
            .finally () => this.isLoading = false
        
        ask_delete: ->
            this.delete_account() if window.confirm(this.$t 'confirm_delete')

        delete_account: ->
            if this.isLoading then return null
            this.loading = true

            u = firebase.auth().currentUser
            try await firebase.firestore().collection('users').doc(u.uid).delete()
            catch e then this.error = e.message; this.loading = false; return false

            try await u.delete()
            catch e then this.error = e.message; this.loading = false; return false

            this.$router.push({name: 'events'})
        
        moment: moment
        open_invoice: (order) -> console.log order.id
        modEvent: ->
            event = 
                description:
                    en: """
                    <span style="font-weight: 500">Boost your business</span>

                    This event is going to be awesome. It's going to feature tonnes of grade A and you'll get a lot out of it. They'll share their recipes for success which you can use to get ahead. Some of the presenters:

                    - Byron Belka, founder
                    - Paul Hickey, investor
                    - Casey Whitaker, global director of customer service
                    - Aaron Palmer, european managing director

                    <span style="font-weight: 500">Program</span>

                    09:30 – 10:00&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Rgistration&nbsp;&nbsp;

                    10:00 – 12:40&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I. general session&nbsp;&nbsp;

                    12:50 – 14:55&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lunch, Store opening&nbsp;&nbsp;

                    14:55 – 17:00&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;II. general session&nbsp;&nbsp;
                    
                    17:00 – 17:20&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Recess&nbsp;&nbsp;

                    17:20 - 18:30&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;III. general session&nbsp;&nbsp;
                    """
                    hu: """
                    <span style="font-weight: 500">Adj lökést az üzletednek</span>

                    Ez a rendezvény tömve lesz elsőosztályú termékekkel és üzletépítési képzéssel, melyet a legjobb vállalati és üzletépítő vezetők tartanak majd szerte a világból. Megosztják majd bizonyított sikerreceptjeiket, amelyek a te üzletépítésedet is jelentősen megkönnyítik, és segítenek majd a következő szintre eljuttatni azt. És természetesen a nagyszerű szórakozás sem hiányozhat majd. Ízelítőül néhányan az előadók közül:

                    - Byron Belka, alapító elnök
                    - Paul Hickey, befektető
                    - Casey Whitaker, globális ügyfélszolgálati igazgató
                    - Aaron Palmer, európai vezérigazgató

                    <span style="font-weight: 500">Program</span>

                    09:30 – 10:00&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Regisztráció&nbsp;&nbsp;

                    10:00 – 12:40&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I. általános ülés&nbsp;&nbsp;

                    12:50 – 14:55&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ebéd, Áruház megnyitó&nbsp;&nbsp;

                    14:55 – 17:00&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;II. általános ülés&nbsp;&nbsp;
                    
                    17:00 – 17:20&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Szünet&nbsp;&nbsp;

                    17:20 - 18:30&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;III. Általános ülés&nbsp;&nbsp;
                    """

            db = firebase.firestore()
            db.collection('events').doc('8tpb0VKMiEFEn0mr33cg').update(event)
            .then -> console.log 'YAAA'
            .catch (e) -> console.log 'NAAAA', e
